// extracted by mini-css-extract-plugin
export default {"input":"SentimentAnalyzer_input__HJ0-K","btn":"SentimentAnalyzer_btn__3gFUM"};